module.exports = __webpack_public_path__ + "img/xiangshui(20).af10eec3.png";